export const create = {
  createSuccessfully: '洗剤の作成に成功しました！',
  createFailed: '洗剤の作成に失敗しました',
}
